<template>
  <v-container class="admin-sasv-tnc" v-if="tnc">
    <v-row>
      <v-col>
        <label class="text-h5">{{ $t('admin_tnc.title') }}</label>
      </v-col>
    </v-row>
    <v-form ref="tncForm">
      <v-row>
        <v-col>
          <v-text-field outlined
                        :rules="requiredRules"
                        :label="$t('admin_tnc.title_en')"
                        v-model="tnc.title_en"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="pt-0">
        <v-col>
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="tnc.content_en">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_tnc.content_en') }}</legend>
              <TinyMceEditor v-model="tnc.content_en"
                             allow-all-style></TinyMceEditor>
            </v-container>
          </v-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field outlined
                        :rules="requiredRules"
                        :label="$t('admin_tnc.title_zh')"
                        v-model="tnc.title_zh"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="pt-0">
        <v-col>
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="tnc.content_zh">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_tnc.content_zh') }}</legend>
              <TinyMceEditor v-model="tnc.content_zh"
                             allow-all-style></TinyMceEditor>
            </v-container>
          </v-input>
        </v-col>
      </v-row>
    </v-form>

    <v-footer app
              inset
              class="pr-6 py-3">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               @click="$refs.tncForm.validate() && save()">{{ $t('save') }}
        </v-btn>
      </v-row>
    </v-footer>
  </v-container>
</template>
<script>
import TinyMceEditor from "@/components/TinyMceEditor";
import {ref, onMounted} from "@vue/composition-api";

export default {
  name: 'SasvTnc',
  components: {TinyMceEditor},
  setup(props, {root}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const tnc = ref(null);

    const save = function () {
      root.$callAPI('sasv/admin/tnc/set/', {
        ...tnc.value,
      }, function (response) {
        tnc.value = response.body;
      });
    };

    onMounted(() => {
      root.$callAPI('sasv/tnc/', {}, function (response) {
        tnc.value = response.body;
      });
    });

    return {
      requiredRules,
      tnc,
      save,
    }
  }
}
</script>
